import {
  LoadDataAction,
  LoadDataSuccessAction,
  LoadDataErrorAction,
  LoadFormDataAction,
  LoadFormDataSuccessAction,
  LoadFormDataErrorAction,
  UploadFileAction,
  UploadFileSuccessAction,
  UploadFileErrorAction,
  DownloadTemplateAction,
  SetModalVisibleAction,
  SetUploadTypeAction,
  SetFileAction,
  ClearModalAction,
  ClearStoreAction,
} from './actions.d';
import actionTypes from './actionTypes';
import {
  ILoadDataPayload,
  ILoadDataSuccessPayload,
  ILoadFormDataSuccessPayload,
  IUploadFilePayload,
  IUploadType,
} from './types';

const actions = {
  loadData: (payload: ILoadDataPayload): LoadDataAction => ({
    type: actionTypes.LOAD_DATA_REQUEST,
    payload,
  }),

  loadDataSuccess: (payload: ILoadDataSuccessPayload): LoadDataSuccessAction => ({
    type: actionTypes.LOAD_DATA_SUCCESS,
    payload,
  }),

  loadDataError: (): LoadDataErrorAction => ({
    type: actionTypes.LOAD_DATA_ERROR,
  }),

  loadFormData: (): LoadFormDataAction => ({
    type: actionTypes.LOAD_FORM_DATA_REQUEST,
  }),

  loadFormDataSuccess: (payload: ILoadFormDataSuccessPayload): LoadFormDataSuccessAction => ({
    type: actionTypes.LOAD_FORM_DATA_SUCCESS,
    payload,
  }),

  loadFormDataError: (): LoadFormDataErrorAction => ({
    type: actionTypes.LOAD_FORM_DATA_ERROR,
  }),

  uploadFile: (payload: IUploadFilePayload): UploadFileAction => ({
    type: actionTypes.UPLOAD_FILE_REQUEST,
    payload,
  }),

  uploadFileSuccess: (): UploadFileSuccessAction => ({
    type: actionTypes.UPLOAD_FILE_SUCCESS,
  }),

  uploadFileError: (): UploadFileErrorAction => ({
    type: actionTypes.UPLOAD_FILE_ERROR,
  }),

  downloadTemplate: (payload: string): DownloadTemplateAction => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_REQUEST,
    payload,
  }),

  setModalVisible: (payload: boolean): SetModalVisibleAction => ({
    type: actionTypes.SET_MODAL_VISIBLE,
    payload,
  }),

  setUploadType: (payload: IUploadType | null): SetUploadTypeAction => ({
    type: actionTypes.SET_UPLOAD_TYPE,
    payload,
  }),

  setFile: (payload: File | null): SetFileAction => ({
    type: actionTypes.SET_FILE,
    payload,
  }),

  clearModal: (): ClearModalAction => ({
    type: actionTypes.CLEAR_MODAL,
  }),

  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
